module.exports = __webpack_public_path__ + "img/finland-liver-cancer-male.8e467eec.png";